import { Alert, AlertColor, Snackbar } from '@mui/material';

interface mySnackBarProps {
    text: string | null;
    severity: AlertColor | null;
    open: boolean;
    onClose: () => void;
}

export const MySnackBar: React.FC<mySnackBarProps> = ({
    text,
    severity,
    open,
    onClose,
}) => {
    return (
        <Snackbar open={open} autoHideDuration={5000} onClose={onClose}>
            <Alert variant="filled" severity={severity ? severity : 'info'}>
                {text}
            </Alert>
        </Snackbar>
    );
};
